/*
 Created by CHT 2019/10/12 11:00
 */
import Address from './Address'
import Attachment from './Attachment'
import Checkbox from './Checkbox'
import Currency from './Currency'
import DateInput from './DateInput'
import DateRange from './DateRange'
import Description from './Description'
// 新增分割线组件
import DividingLine from './DividingLine'
import Digital from './Digital'
import Dropdown from './Dropdown'
import Grade from './Grade'
import ImageAttachment from './ImageAttachment'
import ImageChoose from './ImageChoose'
import Location from './Location'
import Multiline from './Multiline'
import Rtf from './Rtf'
import Sectional from './Sectional'
import SerialNumber from './SerialNumber'
import SingleChoose from './SingleChoose'
import SingleLine from './SingleLine'
import SlidingBlock from './SlidingBlock'
import YesNo from './YesNo'
import Member from './Member'
import Department from './Department'
import Table from "./Table"
import Summary from "./Summary"
import ExternalDataSource from "./ExternalDataSource"
import Phone from "./Phone"
import OutRequest from "./OutRequest"
import Signature from "./Signature"
import Button from "./Button"
import RelateRecord from "./RelateRecord"
import RealTimeData from "./RealTimeData"
import CurrentViewUser from "./CurrentViewUser";
import Cascade from "./Cascade";
import Qrcode from "./Qrcode";
import Video from "./Video";
import Iframe from "./Iframe";
import LarkApproval from "./LarkApproval";
import ThirdDataTable from "./ThirdDataTable";
import ThirdMap from "./ThirdMap";
import LinkQuery from "./LinkQuery";
import {FORM_ITEM__FLOW_DETAIL_INFO, FORM_ITEM__FORM_RUN_STATUS, FORM_ITEM__FUNCTION} from "../types";

const instances = {
	Address,
	Attachment,
	Checkbox,
	Currency,
	DateInput,
	DateRange,
	Description,
	DividingLine,
	Digital,
	Dropdown,
	Grade,
	ImageAttachment,
	ImageChoose,
	Location,
	Multiline,
	Rtf,
	Sectional,
	SerialNumber,
	SingleChoose,
	SingleLine,
	SlidingBlock,
	YesNo,
	Member,
	Department,
	Table,
  Summary,
	ExternalDataSource,
  Phone,
  OutRequest,
  Signature,
  Button,
  RelateRecord,
  RealTimeData,
  CurrentViewUser,
  Cascade,
  Qrcode,
  Video,
  Iframe,
	LarkApproval,
	ThirdDataTable,
	ThirdMap,
	LinkQuery
}

export const formIconMap = (()=> {
	const obj = {}
	Object.values(instances).forEach(item => {
		obj[item.type] = item.icon
	})
	obj[FORM_ITEM__FORM_RUN_STATUS] = 'iconfont icon-cengji'
	obj[FORM_ITEM__FLOW_DETAIL_INFO] = 'iconfont icon-cengji1'
  obj[FORM_ITEM__FUNCTION] = 'iconfont icon-count'
	return obj
})()

export default instances
